import { getLigne, getDirection, getService } from '../../store/line-store.js'
import { Lignes } from '../../lines.js'

export class LineListModel {
	constructor() {
		this.palette = [
			'#06b6d4',
			'#8b5cf6',
			'#f43f5e',
			'#22c55e',
			'#f59e0b',
			'#3b82f6',
			'#e879f9',
		]
		this.correctOrder = []
		this.items = []
	}

	updateFromStore() {
		if (!Lignes || Lignes.length === 0) return false
		const ligne = Lignes.find((l) => l.ligne === getLigne())
		if (!ligne) return false

		let index = 0
		let serviceName = getService()
		index = ligne.services.findIndex((s, i) => s.name === serviceName)

		console.log(index)
		const direction =
			getDirection() === 'Retour'
				? ligne.services.at(index).retour
				: ligne.services.at(index).aller
		this.correctOrder = Object.values(direction).map((l) => l.name)
		return true
	}

	shuffled() {
		return [...this.correctOrder].sort(() => Math.random() - 0.5)
	}
}
